swup.on('willReplaceContent', function() {
        if(typeof pagespeed == 'undefined') {
            pagespeed = {
                CriticalImages : {
                    checkImageForCriticality: function(that) { }
                }
            }
        }
});
